/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const authenticationAuditPageOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const authenticationAuditPageOutputItemsItemActorRefOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const authenticationAuditPageOutputItemsItemSubjectUserIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const authenticationAuditPageOutputItemsItemActionMax = 100;

export const authenticationAuditPageOutputItemsItemOccurredAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z))$',
);
export const authenticationAuditPageOutputItemsItemDeviceContextBrowserFamilyMax = 80;

export const authenticationAuditPageOutputItemsItemDeviceContextOsFamilyMax = 80;

export const authenticationAuditPageOutputItemsItemReasonCodeOneMax = 100;

export const authenticationAuditPageOutputItemsItemCorrelationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const authenticationAuditPageOutputNextCursorOneMax = 512;

export const authenticationAuditPageOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const AuthenticationAuditPageOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(authenticationAuditPageOutputItemsItemIdRegExp),
      actorKind: zod.enum(['user', 'system', 'deployment', 'unknown']),
      actorRef: zod.union([
        zod.uuid().regex(authenticationAuditPageOutputItemsItemActorRefOneRegExp),
        zod.null(),
      ]),
      subjectUserId: zod.union([
        zod.uuid().regex(authenticationAuditPageOutputItemsItemSubjectUserIdOneRegExp),
        zod.null(),
      ]),
      action: zod.string().min(1).max(authenticationAuditPageOutputItemsItemActionMax),
      occurredAt: zod.iso
        .datetime({ offset: true })
        .regex(authenticationAuditPageOutputItemsItemOccurredAtRegExp),
      deviceContext: zod.object({
        browserFamily: zod
          .string()
          .min(1)
          .max(authenticationAuditPageOutputItemsItemDeviceContextBrowserFamilyMax),
        osFamily: zod
          .string()
          .min(1)
          .max(authenticationAuditPageOutputItemsItemDeviceContextOsFamilyMax),
        category: zod.enum(['phone', 'tablet', 'desktop', 'unknown']),
      }),
      outcome: zod.enum(['success', 'refused', 'unavailable', 'abandoned']),
      reasonCode: zod.union([
        zod.string().max(authenticationAuditPageOutputItemsItemReasonCodeOneMax),
        zod.null(),
      ]),
      changes: zod.union([
        zod.union([
          zod.object({
            oldRole: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
            newRole: zod.union([zod.enum(['Agent', 'Admin']), zod.null()]),
          }),
          zod.object({
            oldState: zod.enum(['active', 'deactivated']),
            newState: zod.enum(['active', 'deactivated']),
          }),
        ]),
        zod.null(),
      ]),
      retentionClass: zod.enum(['routine', 'security']),
      correlationId: zod.uuid().regex(authenticationAuditPageOutputItemsItemCorrelationIdRegExp),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(authenticationAuditPageOutputNextCursorOneMax)
      .regex(authenticationAuditPageOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type AuthenticationAuditPageOutput = zod.input<typeof AuthenticationAuditPageOutput>;
export type AuthenticationAuditPageOutputOutput = zod.output<typeof AuthenticationAuditPageOutput>;
